import { connect } from "react-redux";
import ListAgentsProfilesComponent from "../../Components/Agents/ListAgentsProfilesComponent";
import { setAgentProfiles } from "../../Redux/Actions/AgentProfileActions";

const mapStateToProps = (state) => ({
    AGENT_PROFILES : state.reducer.AGENT_PROFILES,
    SCOPES_NAMES : state.reducer.SCOPES_NAMES,
    ACTIVE_TENANT : state.reducer.ACTIVE_TENANT,
});
const mapDispatchToProps = (dispatch) => ({
    setAgentProfiles: (AGENT_PROFILES) => dispatch(setAgentProfiles(AGENT_PROFILES)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ListAgentsProfilesComponent);